<template>
<div class="footercontainer pt-5">
    <v-container class="mb-5">
    <v-row class="my-0">
        <v-col class="col-12 col-sm-12 col-md-4 col-lg-4">
            <v-img 
                src="../../assets/africanring.jpeg" 
                contain
                max-width="150"
                width="100%"
                class="mb-4"
            />
            <h4 class="white--text">Contact number: <a class="white--text" href="tel:0987654321">0987654321</a></h4>
            <h4 class="white--text">Email: <a class="white--text" href="mailto:danetopham@gmail.com">danetopham@gmail.com</a></h4>
           
        </v-col>
        <v-col class="col-12 col-sm-12 col-md-4 col-lg-4 white--text">
            <h3>Site Links</h3>
            <v-divider color="white"></v-divider>
             <v-list-item class="sitenavs listcolor" v-for="item in items" :key="item.id" :to="item.to">
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ item.title}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col class="col-12 col-sm-12 col-md-4 col-lg-4 white--text">
            <h3>Login or Register</h3>
            <v-divider color="white"></v-divider>
             <v-list-item class="sitenavs listcolor" v-for="register in registers" :key="register.id" :to="register.to">
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ register.title}}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-col>
    </v-row>
  </v-container>
  <lastfooter/>
</div>
</template>

<script>
import lastfooter from "./lastfooter.vue"
export default {
    components: {
        lastfooter
    },
    data: () => ({
        items: [
          { title: 'Home', icon: 'mdi-view-dashboard', to: '/' },
          { title: 'Fights', icon: 'mdi-login-variant', to: '#' },
          { title: 'Fighters', icon: 'mdi-account-plus', to: '#' },
        ],
        registers: [
          { title: 'Login', icon: 'mdi-login-variant', to: '/login' },
          { title: 'Register', icon: 'mdi-account-plus', to: '/subscribe' },
        ],
    })
}
</script>

<style lang="sass">
.footercontainer
    background: #000

.v-application a 
    color: #000 !important
a 
 text-decoration: none
</style>